import { DestroyRef, effect } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { fromEvent } from 'rxjs';

export function useBeforeUnload(shouldWarn: () => boolean, destroyRef: DestroyRef) {
  effect(() => {
    fromEvent<BeforeUnloadEvent>(window, 'beforeunload')
      .pipe(takeUntilDestroyed(destroyRef))
      .subscribe(event => {
        if (!shouldWarn()) {
          event.preventDefault();
          event.returnValue = '';
        }
      });
  });
}
